<template>
  <div class="infor fl">
    <all-header
      :label="lable"
      :ischage="ischage"
      :sublabel="sublabel"
      :subtitle="subtitle"
      @getvalue="goBack"></all-header>

    <el-table
      :data="list"
      v-loading="loading"
      :header-cell-style="{ background: '#F3F6FF', color: '#7C828A' }"
      style="width: 100%; margin-top: 20px"
      empty-text="暂无记录"
    >
      <el-table-column label="序号" width="80">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="申报名称" min-width="240" prop="award_title" />
      <el-table-column label="证书数量" min-width="120" prop="cert_count" />
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="{ row }">
          <el-button
            v-if="row.cert_count > 0"
            size="mini"
            type="primary"
            @click="onQuery(row)"
          >查询证书</el-button>
          <span v-else class="empty-action">暂无证书</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { CertificateSummary } from '../utils/api.js';
import AllHeader from './Modal/AllHeader.vue';

export default {
  name: 'CertificatesSummary',
  components: {
    AllHeader,
  },
  data() {
    return {
      loading: false,
      list: [],
      sublabel: '返回记录列表',
      subtitle: '',
      ischage: true,
      lable: '',
    };
  },
  mounted() {
    this.lable = this.$route.query.name || '荣誉证书';
    this.loadList();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const res = await CertificateSummary();
        const rawList = res.data || res || [];
        const allowTitles = ['工程建设质量管理小组竞赛活动', '建筑与市政工程绿色施工评价'];
        const baseMap = rawList.reduce((acc, item) => {
          if (item && item.award_title) acc[item.award_title] = item;
          return acc;
        }, {});
        const defaults = allowTitles.map((title) => ({
          award_title: title,
          cert_count: 0,
          award_id: baseMap[title]?.award_id || null,
        }));
        this.list = defaults.map((row) => baseMap[row.award_title] ? { ...row, ...baseMap[row.award_title] } : row);
      } catch (e) {
        this.$message.error('加载列表失败');
      } finally {
        this.loading = false;
      }
    },
    onQuery(row) {
      this.$router.push({
        path: '/member/certificates/list',
        query: {
          award_id: row.award_id,
          name: '荣誉证书明细',
          award_title: row.award_title,
        },
      });
    },
    goBack() {
      this.$router.push('/member/Declar_record?name=申报记录');
    },
  },
};
</script>

<style lang="less" scoped>
.infor-t-r {
  padding: 6px 14px;
  border: 1px solid #5d8dff;
  color: #5d8dff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
}

.empty-action {
  color: #999;
  font-size: 12px;
}
</style>
